
import { useContext } from "react";

import { ViewContext } from "../state/view";

import { findViewById } from "../lib/helper";

export function Hero() {

  const { view } = useContext( ViewContext );

  const { subheader } = findViewById( view );

  return (

    <div className="bg-blue-primary bg-none sm:bg-[url(./images/hero-pattern.png)] bg-no-repeat bg-cover bg-position-[center_top_200px] lg:bg-position-[center_top_125px] h-90 sm:h-125 lg:h-[534px] w-full flex justify-center py-15 sm:py-20 lg:py-25 px-6 lg:px-10">

      <div className="max-w-5xl text-center h-32 sm:h-48 lg:h-62 flex flex-col justify-between gap-2">

        <h1 className="font-bold text-white text-3xl sm:text-5xl lg:text-7xl">How optimized is your microbiology laboratory?</h1>

        <p className="text-green-bitter-lemon text-xl sm:text-3xl">{ subheader }</p>

      </div>

    </div>

  );

}
